import nl from './nl'
import es from './es'

export default {
  nl,
  es,
}
